import TApplicationInviteUserRegistrationComplete from './index.vue';

TApplicationInviteUserRegistrationComplete.install = app => {
  app.component(TApplicationInviteUserRegistrationComplete.name, TApplicationInviteUserRegistrationComplete);
};

export default TApplicationInviteUserRegistrationComplete;
